import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import { AirportInfoProvider } from '../core/context/AirportInfoContext';

import FlightEventContainer from '../forms/FlightEvent/FlightEventContainer';
import CabinEventContainer from '../forms/CabinEvent/CabinEventContainer';
import DispatchEventContainer from '../forms/DispatchEvent/DispatchEventContainer';
import IncidentEventContainer from '../forms/Incident/IncidentEventContainer';
import FlightOperationNotificationContainer from '../forms/FlightOpNotification/FlightOperationNotificationContainer';
import SafetyEventContainer from '../forms/SafetyEvent/SafetyEventContainer';

function Form() {
  return (
    <AirportInfoProvider>
      <Routes>
        <Route path="flight-event/*" element={<FlightEventContainer />} />
        <Route path="cabin-event/*" element={<CabinEventContainer />} />
        <Route path="dispatch-event/*" element={<DispatchEventContainer />} />
        <Route path="incident/*" element={<IncidentEventContainer />} />
        <Route path="flight-operation-notification/*" element={<FlightOperationNotificationContainer />} />
        <Route path="safety-event/*" element={<SafetyEventContainer />} />
      </Routes>
    </AirportInfoProvider>
  );
}

export default Form;
